(function() {
  var $9583a737dfb9e78a$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("floating-field")) return;
    customElements.define("floating-field", class FloatingField extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector("[data-floating-input]");
        if (!this.input) return;
        this._onFocus = this._onFocus.bind(this);
        this._onBlur = this._onBlur.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onChange = this._onChange.bind(this);
        this.input.addEventListener("focus", this._onFocus);
        this.input.addEventListener("blur", this._onBlur);
        this.input.addEventListener("input", this._onInput);
        this.input.addEventListener("change", this._onChange);
        this._sync();
      }
      disconnectedCallback() {
        this.input?.removeEventListener("focus", this._onFocus);
        this.input?.removeEventListener("blur", this._onBlur);
        this.input?.removeEventListener("input", this._onInput);
        this.input?.removeEventListener("change", this._onChange);
      }
      _onFocus() {
        this.classList.add("is-floating");
      }
      _onBlur() {
        if (!this.input.value) this.classList.remove("is-floating");
        this.classList.toggle("has-value", Boolean(this.input.value));
      }
      _onInput() {
        if (this.input.value) this.classList.add("is-floating");
        this.classList.toggle("has-value", Boolean(this.input.value));
      }
      _onChange() {
        this._sync();
      }
      _sync() {
        const filled = Boolean(this.input?.value);
        this.classList.toggle("is-floating", filled);
        this.classList.toggle("has-value", filled);
      }
    });
  })();
})();